import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/UI/Button';

import { ActionRow, FormPanel, FormSectionTitle } from '../styles';
import { Box } from '@/layout/Box';
import { Check } from '@/components/Icon';
import { theme } from '@/theme/Theme';
import { Text } from '@/components/UI/Typography/Text';
import { Flex } from '@/layout/Flex';

interface Props {
  isMobile: boolean;
  isTablet: boolean;
  referenceId?: string;
}

const SubmittedStep = ({ isMobile, isTablet, referenceId }: Props) => {
  const navigate = useNavigate();
  //   @ts-ignore
  const { t } = useTranslation();

  return (
    <FormPanel isTablet={isTablet}>
      <Flex flexDirection="column" alignItems="center" textAlign="center" gridGap={30}>
        <div>
          <Box flexShrink={0}>
            <Check.CheckSVG width={80} height={80} fill={theme.colors.secondary400} />
          </Box>
          <Text fontSize={theme.fontSizes.md} fontWeight="bold">
            {t('pbl.lawyerRegistration.submitted.title', { defaultValue: 'Application Submitted Successfully' })}
          </Text>
        </div>
        <Flex flexDirection="column" alignItems="center" gridGap={20}>
          <Text fontSize={theme.fontSizes.base} color={theme.colors.gray400}>
            {t('pbl.lawyerRegistration.submitted.thankYou', {
              defaultValue: 'Thank you for registering to join the Panel of Pro Bono Lawyers of FreeLegalLink.',
            })}
          </Text>
          <Text fontSize={theme.fontSizes.base} color={theme.colors.gray400}>
            {t('pbl.lawyerRegistration.submitted.referenceId', { defaultValue: 'Reference ID:' })}
            <br />
            {referenceId ||
              t('pbl.lawyerRegistration.submitted.fallbackReferenceId', {
                defaultValue: '-',
              })}
          </Text>
          <Text fontSize={theme.fontSizes.base} color={theme.colors.gray400}>
            {t('pbl.lawyerRegistration.submitted.contactIfNecessary', {
              defaultValue: 'We will contact you if necessary.',
            })}
          </Text>
        </Flex>
        <Button size="lg" variant="primary" rounded={false} onClick={() => navigate('/')}>
          {t('pbl.common.actions.returnToHome', { defaultValue: 'Return to Home' })}
        </Button>
      </Flex>
    </FormPanel>
  );
};

export default SubmittedStep;
